import { useEffect } from "react"

import { useTranslation } from "lib/i18n/translation"
import { useAnchorNav } from "lib/anchor-nav"
import image, { PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"
import { useToast } from "lib/toast"
import { useAuth } from "lib/auth"

import Image from "components/common/image"
import SkeletonLink from "components/common/skeleton-link"
import ProductAccessLink from "components/common/product-access-link"
import handleShare from "../../lib/playlists/handle-share"

const PlaylistPublic = ({ title, playlist, products }) => {
	const { c } = useTranslation("common")
	const { show } = useToast()
	const { user } = useAuth()
	const { isSectionsSetted, setSectionLoaded } = useAnchorNav()

	useEffect(() => {
		setSectionLoaded(title)
	}, [isSectionsSetted])

	return (
		<>
			<section className="focus has-splitted black">
				<div className="splitted large invert">
					<figure className="avatar playlist">
						<span className="icon-user"></span>
					</figure>
					<div className="content">
						<h1 className="title-alt">{playlist.name}<br />{c("by")} <strong>
							<span dangerouslySetInnerHTML={{ __html: playlist.username }}></span>
							</strong>
						</h1>
						<nav className="focus-nav alt" aria-label="Actions playlist">
							<a
								onClick={handleShare(c, show, playlist)}
								rel="nofollow noopener"
								title={c("playlist-share")}
								className="icon-share"
								data-overlay="#overlay-playlist-share">
								{c("share")}
							</a>
						</nav>
					</div>
				</div>
			</section>
			<section>
				{
					(playlist.note && playlist.note.length > 0)
					&& <div className="columnizer" data-columns="1">
						<p dangerouslySetInnerHTML={{ __html: playlist.note.replace(/\n/g, "<br>") }}></p>
					</div>
				}
				<ul className="list playlist films playlist-list has-comments">
					{
						products.map(product => {
							return (
								<Film key={`movie-${product.linkRewrite}`} product={product} c={c} user={user} />
							)
						})
					}
				</ul>
			</section>
		</>
	)
}

const Film = ({ product, c, user }) => {
	return (
		<li className="item in-selection">
			<div className="item-content">
				<figure className="cover">
					<picture>
						<Image src={image(product, PRODUCT_PHOTOGRAMME)} alt={product.name} className="cover" />
					</picture>
				</figure>
				<div className="infos">
					<SkeletonLink
						href={"/film/[id]"}
						as={`/film/${product.linkRewrite}`}
						className="film-link">
						<a title={c("see-single-film")} className="film-link">
							<h3 className="title">
								{product.name}
								{
									product.original_title
									&& <span className="original">({product.original_title})</span>
								}
							</h3>
						</a>
					</SkeletonLink>
					<div className="film-infos">
						<span className="director">{product.director}</span>
						<span className="year">{product.year}</span>
						<span className="country">{product.origin}</span>
						<span className="duration">{product.duration}</span>
					</div>
				</div>
			</div>
			<nav className="film-actions" aria-label={c("film-actions")}>
				<ProductAccessLink product={product} />
			</nav>
		</li>
	)
}

export default PlaylistPublic
